import { Avatar, Container, IconButton, Typography } from '@mui/material';

import React, { useContext, useEffect, useState } from 'react';
import { AppContext } from '../../../context/AppContext';

import usuario from '../../../assets/images/usuario.png';
import PerfilForm from '../../forms/Perfil';
import './aspirantes.css';

import { Box } from '@mui/system';
import { AddAPhoto, ContactEmergencySharp } from '@mui/icons-material';

import Resizer from 'react-image-file-resizer';
import Swal from 'sweetalert2';
import { axiosImg, axiosPdf } from '../../../helpers/axios';
import { RouteContext } from '../../../context/RouteContext';
import { block, unblock } from '../../../helpers/loading';

export const CarnetPage = () => {
	const { user, resetLogin } = useContext(AppContext);
	const { convo } = useContext(RouteContext);

	useEffect(() => {
		if ((carnet.foto !== '') & (carnet.foto !== null)) {
			const probando = 'data:image/png;base64,' + carnet.foto;
			setSelectedImage(probando);
		}
	}, []);

	const { carnet, identidad } = user;
	const [selectedImage, setSelectedImage] = useState(usuario);

	const resizeFile = (file) =>
		new Promise((resolve) => {
			Resizer.imageFileResizer(
				file,
				100,
				120,
				'JPG',
				70,
				0,
				(uri) => {
					resolve(uri);
				},
				'base64' //base64, blob, file
			);
		});

	const onChangePhoto = async (event) => {
		const file = event.target.files[0];
		if (file['type'] === 'image/jpeg' || file['type'] === 'image/jpg' || file['type'] === 'image/png') {
			try {
				const image = await resizeFile(file);

				var base64str = image.split('base64,')[1];
				var decoded = atob(base64str);

				var size = parseFloat(decoded.length / 1000).toFixed(2);

				if (size > 4000) {
					Swal.fire('Error', 'El tamaño del archivo seleccionado supera los 4MB', 'error');
				} else {
					const id = {
						carnet: identidad,
						convocatoria_id: convo,
					};
					axiosImg('file', image, id)
						.then((response) => {
							resetLogin();
							setSelectedImage(image);
						})
						.catch((error) => {
							//hacer algo
						});
				}
			} catch (err) {
				console.log(err);
			}
		} else Swal.fire('Error', 'Solamente puede subir imágenes', 'error');
	};

	const onGenerateCarnet = async (event) => {
		//	block();
		const resp = await axiosPdf('file', {
			identidad: identidad,
			convocatoria_id: convo,
		});
		const pdf = new File([resp.data], 'Carnet.pdf', { type: 'application/pdf' });
		window.open(URL.createObjectURL(pdf), '_blank');
		//	unblock();
	};

	return (
		<div>
			<Container maxWidth="lg" align="center">
				<Typography variant="h5">Carnet de Admisión</Typography>

				<div className="content">
					<div className="first">
						<Box mt={8} alignItems="center" style={{ botton: '10%' }}>
							{/* 			<img src={selectedImage} alt={selectedImage.name} height="150px" /> */}
							<Avatar alt="" src={selectedImage} sx={{ width: 140, height: 150 }} />
						</Box>
						<br></br> <br></br>
						<div>
							<IconButton
								color="secondary"
								component="label"
								data-toggle="tooltip"
								data-placement="bottom"
								title="Subir foto"
							>
								<input hidden accept="image/*" type="file" onChange={onChangePhoto} />
								<AddAPhoto />
							</IconButton>
							&nbsp;&nbsp;&nbsp;&nbsp;
							<IconButton
								color="primary"
								component="label"
								data-toggle="tooltip"
								data-placement="bottom"
								title="Generar carnet"
								onClick={() => onGenerateCarnet()}
							>
								<ContactEmergencySharp />
							</IconButton>
							<Typography
								variant="subtitle2"
								gutterBottom
								align="left"
								sx={{ fontWeight: 'bold', fontSize: 12 }}
							>
								Sugerencia para subir fotografía
							</Typography>
							<Typography
								variant="caption"
								display="block"
								gutterBottom
								align="justify"
								sx={{ fontSize: 11 }}
							>
								Usar fotografía reciente del rostro, con fondo uniforme y claro, tomada de frente, sin
								gafas de color oscuro, gorra, etc.
							</Typography>
						</div>
					</div>

					<div className="second">
						<PerfilForm />
					</div>
				</div>
			</Container>
		</div>
	);
};
